import React, { FunctionComponent, useEffect } from "react";

import { Modal } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { getTranslations } from "../../../features/translations/translationsUtils";
import LoadingOverlay from "../../common/LoadingOverlay";
import { fetchCertificatesListByUser, selectCertificateList, selectIsCertificateListFetching } from "../../../features/students/certificateListSlice";
import { goToCertificate } from "../../Students/Course/Congratulations";

import starImage from '../../../assets/Star 1.svg';

import styles from './certificatesModal.module.scss';

interface ICertificatesModalProps {
  userId?: string;
  opened: boolean;
  close: () => void;
}

const CertificatesModalContent: FunctionComponent = () => {
  const fetching = useSelector(selectIsCertificateListFetching);
  const list = useSelector(selectCertificateList);

  if (fetching) {
    return <LoadingOverlay inline spinning height={100} />;
  }
  return <div className={styles.certifications}>
    <img className={styles.image} src={starImage} alt="star" />
    <div className={styles.title}>{getTranslations('PROFILE_OBTAINED_CERTIFICATES')}</div>
    {list.map((item) => {
      return (
        <div className={styles.certificate} key={item._id}>
          <div className={styles.courseName}>{item.courseName}</div>
          <div className={styles.gotoLink}>
            <span
              className={styles.viewButton}
              onClick={goToCertificate(item.hash)}
            >
              {getTranslations('PROFILE_VIEW_CERTIFICATE')}
            </span>
          </div>
        </div>
      );
    })}
    {list.length === 0 && (
      <div className={styles.description}>
        {getTranslations('PROFILE_NO_OBTAINED_CERTIFICATES')}
      </div>
    )}
  </div>;
}

export const CertificatesModal: FunctionComponent<ICertificatesModalProps> = ({
  userId,
  opened,
  close,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (userId && opened) {
      dispatch(fetchCertificatesListByUser(userId));
    }
  }, [userId, dispatch, opened]);

  return <Modal
    closable={true}
    open={opened}
    className={styles.container}
    width={721}
    onCancel={close}
    footer={false}
  >
    <CertificatesModalContent />
  </Modal>;
};